class SwiperSlider extends HTMLElement {
    constructor() {
        super();

        this.selectors = {
            swiper: "swiper-container",
            prevEl: ".custom-prev-button",
            nextEl: ".custom-next-button",
            scrollbar: ".custom-scrollbar"
        };
    }

    connectedCallback() {
        this.slider = this.querySelector(this.selectors.swiper);
        this.buttonPrev = this.querySelector(this.selectors.prevEl);
        this.buttonNext = this.querySelector(this.selectors.nextEl);
        this.scrollbar = this.querySelector(this.selectors.scrollbar);
        this.options = this.slider ? this.slider.getAttribute("data-options") : null;

        if (!this.slider) {
            return null;
        }
        this.addListeners();

        // Defer init until layout is complete so Swiper reads correct container width
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.initSlider();
                this._watchResize();
            });
        });
    }

    _watchResize() {
        if (!this.slider) return;
        // If container still has no width (e.g. inside a hidden tab/accordion),
        // wait for the first resize that gives it real dimensions then update Swiper.
        if (this.offsetWidth > 0) return;
        this._resizeObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                if (entry.contentRect.width > 0) {
                    this._resizeObserver.disconnect();
                    if (this.slider && this.slider.swiper) {
                        this.slider.swiper.update();
                    }
                    break;
                }
            }
        });
        this._resizeObserver.observe(this);
    }

    initSlider() {
        this.destroySlider();

        let inlineOptions = this.slider.dataset.options;

        if (inlineOptions) {
            inlineOptions = JSON.parse(inlineOptions);
        }

        this.swiperParams = {
            slidesPerView: 4,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            watchSlidesProgress: true,
            spaceBetween: 34,
            breakpoints: {
                480: {
                    slidesPerView: "2",
                    spaceBetween: 15,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0
                }
            },
            navigation: {
                nextEl: this.buttonNext,
                prevEl: this.buttonPrev
            },
            scrollbar: {
                el: this.scrollbar,
                draggable: true,
                hide: false
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true
            },
            on: {
                init() {}
            },
            ...inlineOptions
        };

        Object.assign(this.slider, this.swiperParams);

        this.slider.initialize();
    }

    disconnectedCallback() {
        if (this._resizeObserver) {
            this._resizeObserver.disconnect();
        }
        this.destroySlider();
    }

    destroySlider = () => {
        if (this.slider && this.slider.swiper) {
            this.slider.swiper.destroy(true, true);
        }
    };

    addListeners() {
        document.addEventListener("shopify:section:reorder", () =>
            this.initSlider()
        );
        document.addEventListener("shopify:section:load", () =>
            this.initSlider()
        );
        document.addEventListener("shopify:section:select", () =>
            this.initSlider()
        );
        document.addEventListener("shopify:section:deselect", () =>
            this.initSlider()
        );
        document.addEventListener("shopify:block:select", () =>
            this.initSlider()
        );
        document.addEventListener("shopify:block:deselect", () =>
            this.initSlider()
        );
    }
}

customElements.define("component-slider-swiper", SwiperSlider);
